const MODULE_NAME = 'OfflineModule';

// eslint-disable-next-line import/prefer-default-export
export const DELETE_RECORD_FROM_DB = `${MODULE_NAME}/DELETE_RECORD_FROM_DB`;
